var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usertools"},[_c('span',{staticClass:"username"},[_vm._v(_vm._s(_vm.email))]),_c('span',{staticClass:"logout"},[(_vm.uuid)?_c('a',{staticClass:"link",on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }